import RegulationText from '../components/regulationText';
import RegulationForm from '../Regulation/regualtionForm';
import world from '../assets/images/sw-1.png';
import CountryCard from '../components/country/countryCard';
import NG from '../assets/images/NG-1.png';
import DRC from '../assets/images/DRC-1.png';
import GH from '../assets/images/GH-1.png';
import MZ from '../assets/images/MZ-1.png';
const MainCountryOview = () => {
  return (
    <div>
      <div className='w-full xl:px-[110px]  px-[24px] bg-[#F8FAFC] relative min-h-[200px]'>
        <div className='w-full max-w-[1750px] mx-auto py-[10px] z-50'>
          <RegulationText
            title='Country Overview'
            description='Our platform provides detailed mining data across Africa, offering interactive maps, legal insights, and real-time reports. Explore mining sites and stay informed with up-to-date information for all key stakeholders.'
          />{' '}
        </div>
        <img src={world} alt='' className='absolute right-0  top-0 h-[200px]' />
      </div>

      <div className='grid grid-cols lg:grid-cols-3 w-full xl:px-[110px]  px-[24px] mt-10  gap-3  max-w-[1750px] mx-auto'>
        <CountryCard
          country='Nigeria'
          miningData='1,000 Mining sites'
          contribution='1.39tn GDP contribution'
          logo={NG}
          link={'/country-overview?c=Nigeria'}
        />
        <CountryCard
          country='Ghana'
          miningData='~15 Mining sites'
          contribution='6,340.96GHS Million contribution'
          logo={GH}
          link={'/country-overview?c=Ghana'}
        />
        <CountryCard
          country='DRC(Congo)'
          miningData='3,000 Mining sites'
          contribution='6,125CDF Million contribution'
          logo={DRC}
          link={'/country-overview?c=DRC'}
        />
        <CountryCard
          country='Mozambique'
          miningData='1,044 Mining sites'
          contribution='34,809MZN Million contribution'
          logo={MZ}
          link={'/country-overview?c=Mozambique'}
        />
      </div>
    </div>
  );
};

export default MainCountryOview;
